import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Card, Button } from "@lysaab/ui-2";
import "./OnfidoStatusPage.scss";
import { useParams } from "react-router-dom";
import { SignupInfo } from "./SignupInfo";
import { useOnfidoStatus } from "../../hooks/useOnfidoStatus";
import { StatusCardContent } from "./StatusCardContent";
export const OnfidoStatusPage = ({ idProcess, poaProcess, restart }) => {
    const params = useParams();
    const [invalid, setInvalid] = useState(false);
    const { idStatus, poaStatus, error } = useOnfidoStatus(params.signupId);
    const bothClear = ((idStatus === null || idStatus === void 0 ? void 0 : idStatus.status) === "ONFIDO_CLEAR" ||
        (idStatus === null || idStatus === void 0 ? void 0 : idStatus.status) === "LYSA_MANUAL_REVIEW_CLEAR") &&
        ((poaStatus === null || poaStatus === void 0 ? void 0 : poaStatus.status) === "ONFIDO_CLEAR" ||
            (poaStatus === null || poaStatus === void 0 ? void 0 : poaStatus.status) === "LYSA_MANUAL_REVIEW_CLEAR");
    const showNextButton = !bothClear && (idStatus || poaStatus);
    return (React.createElement("div", { className: "onfido-status-page" },
        React.createElement("h2", null,
            React.createElement(FormattedMessage, { id: "onfido.status.title" })),
        React.createElement(SignupInfo, null),
        React.createElement(Card, null,
            React.createElement(StatusCardContent, { signupId: params.signupId })),
        invalid && (React.createElement("div", { className: "input-error" },
            React.createElement(FormattedMessage, { id: "onfido.status.invalid.pending" }))),
        error && (React.createElement(Button, { onClick: restart, block: true, label: React.createElement(FormattedMessage, { id: "onfido.status.retry.button" }) })),
        bothClear && (React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "onfido.status.both_clear" }))),
        showNextButton && (React.createElement(Button, { block: true, onClick: () => {
                if ((idStatus === null || idStatus === void 0 ? void 0 : idStatus.status) === "LYSA_MANUAL_REVIEW" ||
                    (idStatus === null || idStatus === void 0 ? void 0 : idStatus.status) === "ONFIDO_PENDING" ||
                    (idStatus === null || idStatus === void 0 ? void 0 : idStatus.status) === "ONFIDO_PENDING_MANUAL_REVIEW" ||
                    (poaStatus === null || poaStatus === void 0 ? void 0 : poaStatus.status) === "LYSA_MANUAL_REVIEW" ||
                    (poaStatus === null || poaStatus === void 0 ? void 0 : poaStatus.status) === "ONFIDO_PENDING" ||
                    (poaStatus === null || poaStatus === void 0 ? void 0 : poaStatus.status) === "ONFIDO_PENDING_MANUAL_REVIEW") {
                    setInvalid(true);
                    return;
                }
                if (!invalid) {
                    if ((idStatus === null || idStatus === void 0 ? void 0 : idStatus.status) === "ONFIDO_CLEAR" ||
                        (idStatus === null || idStatus === void 0 ? void 0 : idStatus.status) === "LYSA_MANUAL_REVIEW_CLEAR") {
                        poaProcess();
                        return;
                    }
                    idProcess();
                }
            }, label: React.createElement(FormattedMessage, { id: "onfido.status.next" }) }))));
};
